export function isValidUUID(uuid: string): boolean {
  /*
        Function to see if a string is a valid uuid.
        Regex retrieved from SO: https://stackoverflow.com/questions/7905929/how-to-test-valid-uuid-guid
    */
  const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return regex.test(uuid);
}
